import React from 'react';
import { Check, X } from 'lucide-react';

const ConfirmationModal = ({ 
  show, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  if (!show) return null;

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <h2>Confirm Action</h2>
        <p>{message}</p>
        <div className="modal-buttons">
          <button
            className="btn btn-confirm"
            onClick={() => onConfirm(true)}
          >
            <Check size={16} /> {confirmText}
          </button>
          <button
            className="btn btn-cancel"
            onClick={() => onConfirm(false)}
          >
            <X size={16} /> {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;